import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";

// --- IMPORTS COMPONENTES ---
import ClienteAutocomplete from "../../../components/autocomplete/ClienteAutocomplete";

// --- IMPORTS API / AUTH ---
import apiRoutes from "../../../api/apiRoutes";
import { appFetchBlob } from "../../../utils/http";

// --- CONSTANTES ---
const FORMATO_OPCIONES = [
  { id: "EXCEL", label: "EXCEL" },
  { id: "PDF", label: "PDF" },
];
const ESTADO_CLIENTE_ACTIVO_ID = 11;

export default function ReporteFacturacionClientes() {
  const [descargando, setDescargando] = useState(false);
  const [errorValidacion, setErrorValidacion] = useState("");

  // --- ESTADOS DEL FORMULARIO ---
  const [cliente, setCliente] = useState(null);
  const [formato, setFormato] = useState("EXCEL");

  // --- HANDLER CONSULTAR ---
  const handleConsultar = async () => {
    setErrorValidacion("");
    setDescargando(true);

    try {
      const params = new URLSearchParams();

      // Si hay cliente seleccionado, enviamos codigo y nombre
      // Si no, no enviamos nada → trae todos los clientes activos
      if (cliente?.codigo) params.append("codigo", cliente.codigo);
      if (cliente?.nombre) params.append("nombre", cliente.nombre);

      // Selección de URL según formato
      let url;
      if (formato === "PDF") {
        url = apiRoutes.clientes.exportarFacturacionClientesPdf(params);
      } else {
        url = apiRoutes.clientes.exportarFacturacionClientesExcel(params);
      }

      const { blob, filename } = await appFetchBlob(
        url,
        { method: "GET" },
        { showLoading: false }
      );

      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;

      const timestamp = new Date().getTime();
      const extension = formato === "PDF" ? "pdf" : "xlsx";

      a.download =
        filename || `Reporte_Facturacion_Clientes_${timestamp}.${extension}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error(error);
      if (error.status !== 401) {
        setErrorValidacion("No se pudo descargar el reporte.");
      }
    } finally {
      setDescargando(false);
    }
  };

  return (
    <div className="w-full p-4 md:p-6">
      <div className="bg-white border rounded-md shadow-sm">
        {/* HEADER */}
        <div className="px-4 md:px-6 py-4 border-b flex flex-col md:flex-row md:items-center md:justify-between bg-gray-50 gap-2">
          <h2 className="text-lg md:text-xl font-semibold text-gray-800">
            Periodos de facturación de clientes
          </h2>
        </div>

        {/* BODY */}
        <div className="p-4 md:p-6">
          {/* BANNER DE ERROR */}
          {errorValidacion && (
            <div className="mb-6 bg-[#F8D7DA] border border-[#f5c6cb] text-[#721c24] px-4 py-3 rounded flex items-start gap-3">
              <div className="mt-1">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="10" fill="#dc3545" />
                  <path
                    d="M15 9L9 15M9 9L15 15"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="text-sm">
                <ul className="list-disc list-inside ml-2 mt-1">
                  <li>{errorValidacion}</li>
                </ul>
              </div>
            </div>
          )}

          <div className="bg-gray-100 p-4 md:p-8 rounded-md space-y-4 md:space-y-5 max-w-5xl mx-auto">
            {/* CLIENTE */}
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
              <label className="md:w-60 shrink-0 font-bold text-gray-700">
                Cliente:
              </label>
              <div className="w-full">
                <ClienteAutocomplete
                  value={cliente}
                  onChange={(val) => {
                    setCliente(val);
                    setErrorValidacion("");
                  }}
                  estadoId={ESTADO_CLIENTE_ACTIVO_ID}
                />
              </div>
            </div>

            {/* FORMATO */}
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
              <label className="md:w-60 shrink-0 font-bold text-gray-700">
                Formato:
              </label>
              <select
                className="input w-full"
                value={formato}
                onChange={(e) => setFormato(e.target.value)}
              >
                {FORMATO_OPCIONES.map((f) => (
                  <option key={f.id} value={f.id}>
                    {f.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="px-4 md:px-6 py-4 border-t bg-gray-50 flex justify-start">
          <button
            onClick={handleConsultar}
            disabled={descargando}
            className={`flex items-center gap-2 text-white font-semibold py-2 px-10 rounded shadow transition-all ${
              descargando
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-green-800 hover:bg-green-900"
            }`}
          >
            {descargando ? (
              "Generando..."
            ) : (
              <>
                <FaSearch className="text-sm" /> Consultar
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}